import {
  Children,
  cloneElement,
  ComponentProps,
  isValidElement,
  ReactElement,
  ReactNode,
  useContext,
} from 'react';

import { mergeClasses } from '@/utils';

import TableContext from './TableContext';
import TableCell from './TableCell';

const TableFooter = ({ className, children, ...props }: ComponentProps<'tfoot'>) => {
  const { hasCheckBox } = useContext(TableContext);

  return (
    <tfoot
      data-slot="table-footer"
      className={mergeClasses('bg-muted/50 border-t font-medium [&>tr]:last:border-b-0', className)}
      {...props}
    >
      {Children.map(children, (child) => {
        if (isValidElement(child) && hasCheckBox) {
          return cloneElement(child as ReactElement<ComponentProps<'tr'>>, {
            children: (
              <>
                <TableCell />
                {(child as ReactElement<{ children?: ReactNode }>).props.children}
              </>
            ),
          });
        }
        return child;
      })}
    </tfoot>
  );
};

export default TableFooter;
